export default {
  promptFn(state, t) {
    state.prompt = t
  },
  devFn(state, t) {
    state.dev = t
  },
  videoObjFn(state, o) {
    state.videoObj = o
  },
  audioObjFn(state, o) {
    state.audioObj = o
  },
  loadFontFn(state) {
    state.loadFont = true
  },


  // 页面显示与隐藏
  loadingFn(state, t) {
    state.loading = t
  },
  videoComFn(state, t) {
    state.videoCom = t
  },
  resVideoFn(state, t) {
    state.resVideo = t
  },
  lastComFn(state, t) {
    state.lastCom = t
  },
  resVideoObjFn(state, t) {
    state.resVideoObj = t;
  },




  // 记录结果
  recordingFn(state, r) {
    let {
      res,
      index
    } = r;
    // 累计相加分数
    for (let i = 0; i < res.length; i++) {
      state.recording[i] += res[i];
    }

    // 5道题做完后算出结果分数
    if (index === 5) {
      for (let i = 0; i < state.recording.length; i++) {
        let max = 100;
        let min = 90;
        let resScore = (Math.random() * (max - min) + min) *
          state.recording[i] / Math.max.apply(null, state.recording)
        state.score.push(Math.round(resScore))
      }
    }
  },
  sexFn(state, t) {
    state.sex = t;
  },
  // 修改结果数组
  scoreFn(state, arr) {
    state.score = arr
  },
  isWeiXinFn(state, n) {
    state.isWeiXin = n
  },
  lastShowFn(state, t) {
    state.lastShow = t;
  }
}